const SET_BUY_PAGE = 'SET_BUY_PAGE';

export { SET_BUY_PAGE };
